import { NotificationsRepository } from 'packages/notifications/NotificationsRepository';
import { Cursoring } from 'packages/core/Cursoring';
import moment from 'moment';
var _instance = null;
var NotificationsService = /** @class */ (function () {
    function NotificationsService() {
        this.latestUnreadNotifications = {
            items: null,
            pagination: new Cursoring(),
        };
        this.notificationsRepository = new NotificationsRepository();
        // This attribute is to access if the getLatestUnread request failed at some point.
        this.areNotificationsUpToDate = true;
        if (_instance) {
            return _instance;
        }
        _instance = this;
    }
    NotificationsService.prototype.getLatestUnread = function () {
        var _this = this;
        return this.notificationsRepository.unreadMessages().then(function (data) {
            _this.lastUpdateTime = moment();
            _this.latestUnreadNotifications = data;
            _this.areNotificationsUpToDate = true;
            return data;
        }).catch(function () {
            _this.areNotificationsUpToDate = false;
        });
    };
    return NotificationsService;
}());
export { NotificationsService };
